import { useQuery } from "@tanstack/react-query";
import { getEvents } from "../services/apiEvents.js";

export function UseEvents({ country, city } = {}) {
    const {
        isLoading,
        data: rawEvents,
        error,
    } = useQuery({
        queryKey: ["events", { country, city }],
        queryFn: () => getEvents({ country, city }),
    });

    // Sort events by startDatetime ascending (soonest first)
    const events = rawEvents?.slice().sort(
        (a, b) => new Date(a.startDatetime) - new Date(b.startDatetime)
    );

    return { isLoading, events, error };
}
